/**
 * Canonical HTTP method names used across client-side (api-client.ts) and
 * server-side (api-route-utils.ts) fetch helpers.
 */
export const HTTP_METHODS = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  PATCH: "PATCH",
  DELETE: "DELETE",
} as const;

/**
 * Methods that carry a request body and require JSON content-type headers.
 * GET is intentionally excluded — it never sends a body.
 */
export const MUTATION_METHODS = new Set<string>([
  HTTP_METHODS.POST,
  HTTP_METHODS.PUT,
  HTTP_METHODS.PATCH,
  HTTP_METHODS.DELETE,
]);
